import React from "react";
import Cards from "../../components/Cards/Cards";

import "./MainDash.css";
const MainDash = () => {
  return (
    <div className="MainDash">
      <h1>Dashboard</h1>
      <div className="cards-container">
      <Cards />
     
      </div>
    </div>
  );
};

export default MainDash;
